/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_KineticInputs */

const en_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinetic`)
};

const es_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinético`)
};

const fr_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinétique`)
};

const de_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinetisch`)
};

const ja_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キネティック`)
};

const zh_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人动电能`)
};

const ar_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حركية (Kinetic)`)
};

const id_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinetik`)
};

const it_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinetico`)
};

const ru_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кинетические`)
};

const pt_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinético`)
};

const ko_val_kinetic = /** @type {(inputs: Val_KineticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키네틱`)
};

/**
* | output |
* | --- |
* | "Kinetic" |
*
* @param {Val_KineticInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_kinetic = /** @type {((inputs?: Val_KineticInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_KineticInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_kinetic(inputs)
	if (locale === "es") return es_val_kinetic(inputs)
	if (locale === "fr") return fr_val_kinetic(inputs)
	if (locale === "de") return de_val_kinetic(inputs)
	if (locale === "ja") return ja_val_kinetic(inputs)
	if (locale === "zh") return zh_val_kinetic(inputs)
	if (locale === "ar") return ar_val_kinetic(inputs)
	if (locale === "id") return id_val_kinetic(inputs)
	if (locale === "it") return it_val_kinetic(inputs)
	if (locale === "ru") return ru_val_kinetic(inputs)
	if (locale === "pt") return pt_val_kinetic(inputs)
	return ko_val_kinetic(inputs)
});